import MaterialAvatar from "../components/general/MaterialAvatar";
import { ROLES } from "../constants";

export const getRoleFromBaseByRoleID = (roleID: string, roles) => {
    return roles.find((role) => role.roleID === roleID) || "";
};

export const isTeamMember = (roleID: string, roles) => {
    const roleName = getRoleFromBaseByRoleID(roleID, roles).name;

    return roleName.toLowerCase() === ROLES.TEAM_MEMBER;
};

export const getUniqueTeamMembers = (members, roles) => {
    const uniqueMembers = {};

    members.forEach((member) => {
        if (!uniqueMembers[member.userID] && isTeamMember(member.roleID, roles)) {
            uniqueMembers[member.userID] = {
                avatar: (
                    <MaterialAvatar
                        sx={{
                            width: 32,
                            height: 32,
                        }}
                        user={member}
                    />
                ),
                Name: member.name,
                Username: member.username,
                userID: member.userID,
                Roles: getRoleFromBaseByRoleID(member.roleID, roles).name,
            };
        }
    });

    return uniqueMembers;
};
